/**
 * Extract file extension from filename
 * @param fileName - The filename to extract extension from
 * @param uppercase - Whether to return extension in uppercase (default: false)
 * @returns File extension (with or without uppercase based on flag)
 */
export const getFileExtension = (
  fileName: string,
  uppercase: boolean = false
): string => {
  const parts = fileName.split('.');
  const extension = parts.length > 1 ? parts[parts.length - 1] : '';
  return uppercase ? extension.toUpperCase() : extension;
};
